module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-titlen",
    attrs: {
      "id": "fm-3"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('h1', {
    staticClass: "fm-subtitle"
  }, [_vm._v("Inventing the “Divine Self”")]), _vm._v(" "), _c('h1', {
    staticClass: "fm-subtitle0"
  }, [_vm._v("Where We Are Headed")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Everything great in western civilization comes from a struggle against our origins.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("—Camille Paglia"), _c('a', {
    attrs: {
      "href": "#/#footnote-1687",
      "id": "footnote-1687-backlink"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t is well known that many westerners today describe themselves as “spiritual but not religious.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1686",
      "id": "footnote-1686-backlink"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" Paul Heelas and Linda Woodhead define “spirituality” as a life based not on external authorities and expectations but “in deep connection with the unique experiences of my self-in-relation.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1685",
      "id": "footnote-1685-backlink"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" Religion represents a life of “subordinating subjective-life to the ‘higher’ authority of transcendent meaning, goodness and truth, whilst the latter (spirituality) invokes the sacred in the cultivation of unique subjective-life.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1684",
      "id": "footnote-1684-backlink"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" This is because subjective spirituality is individualistic. Though often practiced in community, it is not defined or disciplined by any community. The individual must be free “to relate in a pick-and-choose way to old and new religious narratives, constructing his or her own life-interpreting universe, loosely woven and therefore easy to change.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1683",
      "id": "footnote-1683-backlink"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Trend lines in the United States show that rising interest in “the sacred” is not a harbinger of religious revival among the 4 percent of the US population who identify as atheists."), _c('a', {
    attrs: {
      "href": "#/#footnote-1682",
      "id": "footnote-1682-backlink"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" Rather, it reflects a migration from organized religion, mainly Christianity, to a more self-defined spirituality."), _c('a', {
    attrs: {
      "href": "#/#footnote-1681",
      "id": "footnote-1681-backlink"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" Europe is further down the trail of secularization, and yet it has seen a similar spike in people identifying as “spiritual but not religious.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1680",
      "id": "footnote-1680-backlink"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" At the same time, 41 percent of Europeans consider astrology to be scientific (compared to 70 percent of Europeans considering astronomy scientific)."), _c('a', {
    attrs: {
      "href": "#/#footnote-1679",
      "id": "footnote-1679-backlink"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Overall, 58 percent of eighteen- to twenty-four-year-old Americans believe that astrology is scientific."), _c('a', {
    attrs: {
      "href": "#/#footnote-1678",
      "id": "footnote-1678-backlink"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" The number of US adults who believe in astrology is greater than the combined membership of all mainline Protestant denominations. Moreover, a 2018 Pew Research Center study found that 62 percent of US adults affirm at least one New Age tenet (e.g., spiritual energy in material objects, reincarnation, psychics, astrology), with the number rising to 77 percent among the “spiritual but not religious” category and 62 percent among self-designated atheists, agnostics, or “nothing in particular.” Significantly, US Catholics (70 percent), mainline Protestants (67 percent), and nearly half of evangelicals (47 percent) affirm one New Age tenet as well."), _c('a', {
    attrs: {
      "href": "#/#footnote-1677",
      "id": "footnote-1677-backlink"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" In short, spirituality without religion is more open to views that both modern science and traditional religions (particularly Christianity) consider “superstitious.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1676",
      "id": "footnote-1676-backlink"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" Reincarnation is affirmed by 33 percent of US adults, and even more so by younger generations. Moreover, 29 percent of US adults say they have experienced a “direct revelation from God or other higher power.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1675",
      "id": "footnote-1675-backlink"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" Despite the claim that we live in a disenchanted age, only 4 percent of US adults say they are atheists, and, as noted above, most of them affirm supernatural forces. Reportedly, Wicca is “technically the fastest-growing religion” in America, and interest in witchcraft among the educated is rising."), _c('a', {
    attrs: {
      "href": "#/#footnote-1674",
      "id": "footnote-1674-backlink"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" Among political conservatives, the influence of mind-science theosophy is evident in the popularity of positive-thinking and prosperity-gospel movements."), _c('a', {
    attrs: {
      "href": "#/#footnote-1673",
      "id": "footnote-1673-backlink"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Spirituality without religion is not just a vapid weigh station to atheism, particularly when most atheists affirm some sort of spiritual reality."), _c('a', {
    attrs: {
      "href": "#/#footnote-1672",
      "id": "footnote-1672-backlink"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" Not even in post-Christian Europe is scientific naturalism the victor over religion. Instead, beliefs that would have been considered superstitious by Christians and scientists alike are considered scientific. Like American nonreligious spirituals or nones, Europeans—with a much longer history of secularization—are not less “superstitious” than they have been in the past but actually more so."), _c('a', {
    attrs: {
      "href": "#/#footnote-1671",
      "id": "footnote-1671-backlink"
    }
  }, [_c('sup', [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Consistently, sociologists of religion underscore the point that individual autonomy is the main driver of secularization. One may still be intensely engaged inwardly and privately while being disengaged from bodily and communal practices considered cages of the soul."), _c('a', {
    attrs: {
      "href": "#/#footnote-1670",
      "id": "footnote-1670-backlink"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" Even ideological secularism appears to be compatible with spirituality. As Charles Taylor points out, if one’s measure is “the great historical faiths, or even with the explicit belief in supernatural beings, then it seems to have declined…. But if you include a wide range of spiritual and semi-spiritual beliefs, or if you cast your net even wider and think of someone’s religion as the shape of their ultimate concern, then indeed, one can make a case that religion is as present as ever.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1669",
      "id": "footnote-1669-backlink"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" Like much of secularization itself, secularization theory arose within Christian societies and, for the most part, measures the waning influence of Christian beliefs and practices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At least in Western modernity, spirituality without religion equates roughly to pantheism or panentheism without biblical monotheism, especially as interpreted in Christianity. And, as illustrated vividly in the cases of Socrates and Spinoza, polytheists and theists alike often find such spirituality indistinguishable from atheism. Emerging first as reinterpretations of and dissent from particular doctrines, antitheism has always been a secularizing phenomenon within monotheistic (especially Christian) religions, one led typically by mystics and critics who are ordained clergy. We should not forget that the Enlightenment itself was influenced significantly by “enthusiastic” alternatives to public religion. As Paul Tillich observed:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("It is entirely wrong to place the rationalism of the Enlightenment in contradiction to pietistic mysticism. It is popular nonsense that reason and mysticism are the two great opposites. Historically, Pietism and the Enlightenment both fought against Orthodoxy. The subjectivity of Pietism, or the doctrine of the “inner light” in Quakerism and other ecstatic movements, has the character of immediacy or autonomy against the authority of the church. To put it more sharply, modern rational autonomy is a child of the mystical autonomy of the doctrine of the inner light."), _c('a', {
    attrs: {
      "href": "#/#footnote-1668",
      "id": "footnote-1668-backlink"
    }
  }, [_c('sup', [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Many figures of the Enlightenment were associated with mystical-pantheistic sects. Spinoza, whose work influenced them, belonged to a community of Anabaptists, Baptists, Quakers, and Remonstrants known as Collegiants after his excommunication from the Amsterdam synagogue. Neither secular nor religious (in an orthodox sense), the Collegiants were nevertheless intensely spiritual—in the words of the Marxist historian Leszek Kołakowki, “Chrétiens sans Église.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1667",
      "id": "footnote-1667-backlink"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" This is not the whole story of secularization, much less of modernity, but it is a much larger part of the story than is usually told.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In fact, the phenomenon treated here so infuses our collective memory that we are often unaware of its influence. Rooted in the antipaganism of the Hebrew prophets, Christianity suppressed this aspect of the Western personality, and the Enlightenment folded Christianity itself into the immaturity of superstition. My goal is to conjure this repressed memory and to recognize it as a formative and enduring legacy in the narrative of modernity. In this volume I am interested especially in the emergence of the notion of the “divine self” that lies at the heart of a major transition from a locative to a utopian cosmos that I explain below.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAMAN AND THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AGE:")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RONZE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACKDROP TO THE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XIAL")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GE")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Arising in the fourth millennium BCE in the Fertile Crescent between the Tigris and the Euphrates, the Mesopotamian city of Sumer became one of the cradles of civilization where protowriting and technological advances flourished. Within a few centuries, Ur emerged as an even greater Sumerian city ruled by a king. Later the Akkadians, an East Semitic group, displaced the ruling class of Ur and established the first Mesopotamian empire there (2350–2150 BCE).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("However, Indo-Iranian migrations from the steppes of Russia and central Asia in the next millennium would change history’s course."), _c('a', {
    attrs: {
      "href": "#/#footnote-1666",
      "id": "footnote-1666-backlink"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" Sharing a common language, cult, and customs—including their invention of the war chariot—the Indo-Iranians branched into Iranian and Indo-Aryan peoples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Launching the first wave, Indo-Aryans migrated to the Indus Valley civilization, which encompassed much of today’s Pakistan, Afghanistan, and northwestern India."), _c('a', {
    attrs: {
      "href": "#/#footnote-1665",
      "id": "footnote-1665-backlink"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" From 1500 to 500 BCE, Indo-Aryans dominated all but southern India, with the Kuru Kingdom becoming the first organized state on the Indian subcontinent. The Indian branch also produced a number of significant migrations westward, including some to the Mediterranean where they became the ruling elite of the Hurrian-speaking Mitanni kingdom of the Levant and eastern Anatolia. In a second wave of migrations, Iranians settled in Mesopotamia, replacing the Akkadian Empire with the Old Babylonian Empire (1894–1598 BCE).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Across these Bronze Age societies, the following features are generally recognizable. Most of these Bronze Age societies possessed a cosmotheogonic myth of chaos-to-cosmos that justified the rites prescribed by the triumphant generation of deities ruling the holy city through a divine king. Signaling divine inspiration, these myths were written in epic poetry that had often been circulated orally in songs for centuries prior to being recorded. One of the earliest, written in Sumero-Akkadian cuneiform script, was the Mesopotamia Enuma Elish."), _c('a', {
    attrs: {
      "href": "#/#footnote-1664",
      "id": "footnote-1664-backlink"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" Several centuries later, Vedic Sanskrit emerged, forming the earliest layers of the Rigveda."), _c('a', {
    attrs: {
      "href": "#/#footnote-1663",
      "id": "footnote-1663-backlink"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" The Rigveda consists of 1,028 hymns whose earliest layers were transmitted orally from 1500 to 1200 BCE by Indo-Aryan tribes as they migrated from Afghanistan through Pakistan into northern India. The distinctively Iranian Avesta is a collection of texts written in Old Avestan. Like the early layers of the Rigveda, the oldest substrate of the Avesta consists of hymns and liturgical formulas, including hymns to individual divinities ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yazatas")]), _vm._v("). The common origin of Indic and Iranian peoples is evident in their shared use of cognate terms and especially the names of divinities."), _c('a', {
    attrs: {
      "href": "#/#footnote-1662",
      "id": "footnote-1662-backlink"
    }
  }, [_c('sup', [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Significantly, these oldest forms of writing are religious epics—theogonic-cosmological myths relating the evolution of the visible world from the bodies of the gods. These epics are characterized by an emphasis on how the present generation of gods, after vanquishing their parents, came to rule the known world. Turning chaos into the beautifully ordered cosmos, the divine family in these myths establishes the social order along with the rituals that humans must perform in order to keep the polis from returning to confusion. These epic poems reflect the shift in Bronze Age civilizations from tribal warfare to settled life. Their chief concern is security within the walled city wherein culture flourishes from generation to generation. Like Russian dolls, the individual is embedded in the family, which is embedded in the polis of the divine warrior-king who guards the internal and external boundaries. The human king is the image of the king of the gods.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The supreme divinity of Indo-European mythologies is almost universally represented as the thunderbolt-hurling god of sky and storm."), _c('a', {
    attrs: {
      "href": "#/#footnote-1661",
      "id": "footnote-1661-backlink"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" However, not even this god is omnipotent. Due to a foolish mistake, Indra allows the evil spirits to enter the world, precipitating a career of perpetual war much like Ahura Mazda’s battle against Ahriman and his demonic hosts. Moreover, the chief deity can behave in unpredictable ways as the cause of both prosperity and destruction. Set reflects this duality in Middle Egyptian myths. Although he can be destructive, Set also accompanies Ra in his solar barque, defeating the chaos serpent Apep. However, in the Osiris cycle of the Late Period, Set is unambiguously evil and the source of chaos."), _c('a', {
    attrs: {
      "href": "#/#footnote-1660",
      "id": "footnote-1660-backlink"
    }
  }, [_c('sup', [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The founding myth also sanctions the cult. Only by performing perfectly the rites prescribed by the gods, including the annual renewal of the king’s mandate by the chief deity (“Mandate from Heaven” in China), is prosperity assured. The gods do not exist outside the world, nor did they create it. Rather, they are the senior members of the community. Culture is cultic. The cult centers on rituals, and the rituals secure a long life of flourishing in the earthly city founded by the gods rather than in another world. If there is such an idea as immortality, it is achieved through offspring who contribute to the further good of the city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Catastrophes of various sorts led to the Bronze Age Collapse (1200–1150 BCE), which occurred in northern India and throughout the Mediterranean."), _c('a', {
    attrs: {
      "href": "#/#footnote-1659",
      "id": "footnote-1659-backlink"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" The Hittite Empire was toppled and proud cities, after being plundered, were reduced to ruins."), _c('a', {
    attrs: {
      "href": "#/#footnote-1658",
      "id": "footnote-1658-backlink"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" Fleeing invaders from the sea, waves of refugees fled to other countries or to their own countryside to eke out a meager existence on small farms in villages."), _c('a', {
    attrs: {
      "href": "#/#footnote-1657",
      "id": "footnote-1657-backlink"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" The only semblance of civilization was the vast sea-bound “empire” of the Phoenicians. Headquartered in modern Lebanon, it ringed the entire Mediterranean from Cyprus to Egypt and the Iberian Peninsula, but it was basically a company with commercial rather than political ambitions. The dissolution of the Kuru Kingdom in northern India around 900 BCE marked the collapse of the Rigvedic civilization. Egypt barely survived through these centuries, known as its Third Intermediate Period. Regardless of what may have caused this widespread collapse, Michael Grant represents the mainstream consensus when he says, “There was a gigantic series of migratory waves, extending all the way from the Danube valley to the plains of China.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1656",
      "id": "footnote-1656-backlink"
    }
  }, [_c('sup', [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Throughout Asia and Egypt as well as Thrace and Greece a massive transformation occurred, which was marked by the ascent of the Assyrians. Growing steadily from a regional power, the Neo-Assyrian Empire lasted from the tenth to the seventh centuries. Like most of its successors, this empire was ruthless—for example, inculcating an imperial rather than local identity by deporting entire populations to other regions. Yet it was profuse in its advances, including a postal system and highways. In cultural life generally we discern a movement from chaos to order, from division to unity, from the many to the One.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A brief Neo-Babylonian Empire (612–539 BCE), marked by Judah’s exile under Nebuchadnezzar II, was toppled by the Achaemenid Persian Empire led by Cyrus the Great. Johann P. Arnason observes, “Persian rule in the Near East was the culminating phase of a process that began when eighth-century Assyria embarked on an unprecedented project of world empire.” Unprecedented exchange occurred within a realm that reached from the Danube to India and from the Black Sea to Egypt. Interactions between India and China during this period are hotly debated. While there are exaggerations on both sides, one conclusion seems obvious: “there was more interaction across the Eurasian microregion, before and during the Axial Age, than earlier historians tended to think.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1655",
      "id": "footnote-1655-backlink"
    }
  }, [_c('sup', [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If civilization were to recover, it could never again depend on local kings invested with sacred authority but who were despotic and ineffective. India’s new religions were born during its Second Urbanization period. Recovering from its “Dark Age” about a century later than these other civilizations, Greece began its migration from division toward unity. Among the chief signs of this movement are colonization, immigration of skilled workers, and urbanization. Coin currency rendered commerce more universal and mobile but also contributed to depersonalized social relations."), _c('a', {
    attrs: {
      "href": "#/#footnote-1654",
      "id": "footnote-1654-backlink"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" Security and prosperity required a new social order of laws and participation by free citizens (i.e., male landowners). Christian Meier calls it “the emergence of the political.” Each group would choose a location for a settlement placed within a hilltop fort ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("polis")]), _vm._v(") around which a new city grew."), _c('a', {
    attrs: {
      "href": "#/#footnote-1653",
      "id": "footnote-1653-backlink"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" While elsewhere power was still the dominant driver, Greeks were compromising and reasoning about the good city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Phoenician immigrants brought alphabetic writing to the Greeks just in time for them to record the works of Homer, rendering obsolete the wide variations of these myths brought by traveling rhapsodes. Writing contributed to the shift from the local, concrete, diverse, and flexible communities based on oral communication to an emphasis on the universal, abstract, unified, and unvarying. The result was a massive disembedding and the rise of the autonomous individual. These trending shifts from the particular to the universal, the many to the One, the local to the global, the oral to the written, are bound up with the shift from locative to utopian. Uprooted from kith and kin, people belonged to an increasingly universal and abstract thing called society. No more than in an extensive canyon is the formation entirely homogeneous, yet distinct layers of sedimentation are recognizable and consistent along its length and breadth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At the same time, across these diverse civilizations we see revolutions in religion. In its broadest horizon of meaning, this phenomenon represents a transition toward what Copleston described as the “Religion of the One.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1652",
      "id": "footnote-1652-backlink"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" During this period we witness a rather sharp and deliberate break with tradition, especially with its founding myths and ritualistic orientation focused on preserving the present order, in the direction of more abstract and philosophical doctrines. There are striking parallels even with respect to the new myths and concepts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At the cosmic level, this is represented by the idea of the emanation of everything that is real from a single and absolute source, spreading like fireworks into a dazzling appearance of diversity and returning to its real being as a simple unity. At the microcosmic level, this idea is represented by the doctrine of transmigration (i.e., reincarnation). Emanating from the divine All, the Soul becomes divided into souls by falling into a body. Yearning for the All, souls hope to return to their proper unity after passing through many lives, meriting escape from the wheel of birth and rebirth. This doctrine of emanation-and-return appeared in various civilizations at the same time without precedent in their earlier religious traditions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("That a major transition occurred around the sixth century BCE is difficult to deny. Under the astonishingly successful reigns of Cyrus the Great and Darius I, the Persian Empire became the most expansive power of its time, stretching from northern India to the Danube and from the Black Sea to Egypt. During this same century Confucius and Mencius, along with their mystical Taoist rivals Lao-Tse (Laozi) and Chuang Tzu (Zhuangzi); the Hinduism of the Upanishads; Jainism; Gautama Buddha; Zoroaster; the Hebrew prophets; and the Greek philosophers and tragedians all flourished. In short, the sixth century gave birth to universal religions that were more philosophical and oriented toward individual spirituality, transcendence, and unity with the divine All."), _c('a', {
    attrs: {
      "href": "#/#footnote-1651",
      "id": "footnote-1651-backlink"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" Across these diverse civilizations the so-called One and the Many Problem was a pressing issue on various levels: sociopolitical and economic no less than religious and philosophical."), _c('a', {
    attrs: {
      "href": "#/#footnote-1650",
      "id": "footnote-1650-backlink"
    }
  }, [_c('sup', [_vm._v("38")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XIAL")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GE")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One prominent theory for this phenomenon was proposed in 1953 by the philosopher Karl Jaspers: “It would seem that the axis of history is to be found in the period around 500 B.C.,” he says, “in the spiritual process that occurred between 800 and 200 B.C…. It is there that we meet with the most deepcut dividing line in history. Man, as we know him today, came into being. For short we may style this the ‘Axial Period.’”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1649",
      "id": "footnote-1649-backlink"
    }
  }, [_c('sup', [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jaspers discerns clear features of such axiality. “What is new about this age, in all three areas of the world,” says Jaspers, “is that man becomes conscious of Being as a whole, of himself and his limitations. He experiences the terror of the world and his own powerlessness. He asks radical questions. Face to face with the void he strives for liberation and redemption.” Setting up for himself “the highest goals,” this new self “experiences absoluteness in the depths of selfhood and in the lucidity of transcendence.” This transcendence is twofold: the divine world above and beyond this one and the self’s own ability to transcend the limits of the visible world. The highest point of transcendence is the deepest and truest self, expressed in the Upanishads’ formula “Atman is Brahman” (4).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No longer taking for granted one’s boundedness, embeddedness, and embodiment in a concrete social, political, and historical context, this new self strives for universality. “As a result of this process, hitherto unconsciously accepted ideas, customs and conditions were subjected to examination, questioned and liquidated.” From mythological thinking to a new stance of critical reasoning, religion became ethical and mythic, and rather than signifying particular events, “was turned into parable.” In short, “This overall modification of humanity may be termed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("spiritualization")]), _vm._v("…. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("speculative thought")]), _vm._v(" he lifts himself up towards Being itself, which is apprehended without duality in the disappearance of subject and object, in the coincidence of opposites … a coming-to-oneself within Being … as becoming one with the Godhead” (1–3).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This transcendent orientation, Jaspers continues, led to a transition from mythological thinking to rationalization ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mythos")]), _vm._v(" to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("logos")]), _vm._v("). Rather than discovering an origin and a goal within history, the divine self finds this unity in an eternal cosmic process of emanation from the All into diversity and return to unity. “For the first time "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("philosophers")]), _vm._v(" appeared…. Hermits and wandering thinkers in China, ascetics in India, philosophers in Greece and prophets in Israel all belong together, however much they may differ from each other in their beliefs, the contents of their thought and their inner dispositions…. He discovered within himself the origin from which to raise himself above his own self and the world” (3).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("For Jaspers and many scholars who adopt his thesis today, “axiality” is like a Platonic form transcending actual historical particulars. Jaspers concentrates on “the common element.” It is hardly a coincidence that Axial revolutions continue to be felt all around the world to the present, but they bear in themselves “this common element” that originated specifically in these civilizations simultaneously (9).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jaspers is not ashamed to be an evangelist for the Axial Age. In fact, his zeal is evident in the epithets he attributes: “The whole of humanity took a forward leap…. Thus the higher we ourselves ascend, the more clearly do we see the Axial Period” (4). Though not subject to proof, “it can, however, be substantiated through a widening and deepening of the conception.” As Jaspers writes, critics objected to Hegel’s attempt to bring together “China, India and the West as stages in the dialectical sequence of the development of the spirit” on the basis that there is no historical evidence of such dependence. “Our thesis, however, involves something altogether different…. The true situation was rather one of contemporaneous, side by side existence without contact…. There are three independent roots of one history, which later—after isolated and interrupted contacts, finally only a few centuries ago and properly speaking not until our own day—become a single unity” (10–11). It is not a mere parallelism of certain features here and there, but a “total universal parallelism on the plane of world history” (12). Whenever and wherever such “breakthroughs to transcendence” appear, they are the effective history of the Axial Age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is clear that “breakthroughs” (or enlightenments) are measured by their correspondence to the development that has been most clearly achieved in Western mysticism. Writing in the aftermath of two world wars, Jaspers the existentialist philosopher is dedicated to a creed: “My outline is based on an article of faith: that mankind has one single origin and one goal,” although (contra Hegel) these are completely unknowable and only discerned here and there in symbols (xv). It was “a deep breath bringing the most lucid consciousness” (2, 51).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Following Jaspers, many advocates of the Axial Age thesis are apologists for a nondogmatic, pantheistic/panentheistic, experientialist, and individualist spirituality. The Axial Age has also been called the “Great Leap of Being” and the “Great Transformation.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1648",
      "id": "footnote-1648-backlink"
    }
  }, [_c('sup', [_vm._v("40")])]), _vm._v(" These epithets play up the generally sympathetic, sometimes even apologetic, character of the Axial Age thesis. Walter Burkert is certainly right in his observation that academic research has been a “battlefield between rationalists and mystics since the beginning of the nineteenth century.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1647",
      "id": "footnote-1647-backlink"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" Both assume a metanarrative of progress from immaturity to enlightenment. They agree that this path travels from dependence on authority to individual autonomy. Where they diverge is in the genealogy that led to modernity. In this sense, both are metanarratives as defined by Lyotard."), _c('a', {
    attrs: {
      "href": "#/#footnote-1646",
      "id": "footnote-1646-backlink"
    }
  }, [_c('sup', [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Far from being a dispassionate historical account, the Axial Age thesis itself belongs to the reception history it seeks to explain. It emerges from a history of conservative Catholic interests to show that Christianity is the result of a fusion of Greek and biblical ideas."), _c('a', {
    attrs: {
      "href": "#/#footnote-1645",
      "id": "footnote-1645-backlink"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(" Jan Assmann’s criticism of the thesis is apt:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Jaspers’ theory of the Axial Age with its characteristic traits of “modernity” is not only a self-portrait or a cultural autobiography but also a normative mirror, confronting modern man with an image of how he should be. As far as the Western part of the Axial hemisphere is concerned, the concept of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Geist")]), _vm._v(" [Spirit] … plays in fact an enormous and ever-increasing role in the cultural texts of the ancient, especially (neo-)Platonic, Jewish, Christian, and, above all, Gnostic worlds."), _c('a', {
    attrs: {
      "href": "#/#footnote-1644",
      "id": "footnote-1644-backlink"
    }
  }, [_c('sup', [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I share Assmann’s suspicion that for Jaspers the Axial Age is equivalent to the way Christianity talks about the incarnation, even dividing history into before and after Christ."), _c('a', {
    attrs: {
      "href": "#/#footnote-1643",
      "id": "footnote-1643-backlink"
    }
  }, [_c('sup', [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jaspers’s account also reads like a new myth of creation, fall, and redemption. Despite his repeated screeds against dogmatism, his thesis is quite dogmatic. Although he inveighs against the “exclusive truth” claimed by particular religions, he seems to endorse quite distinct dogmas."), _c('a', {
    attrs: {
      "href": "#/#footnote-1642",
      "id": "footnote-1642-backlink"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" As Assmann observes, Jaspers treats all of humanity as originating in the Axial Age, such that around 500 BCE “Man, as we know him today, came into being.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1641",
      "id": "footnote-1641-backlink"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" However, there was a fall: “When the age lost its creativeness, a process of dogmatic fixation and levelling-down took place in all three cultural realms.” Obsession with rational organization and planning built universal empires, quenching much of the original spirit."), _c('a', {
    attrs: {
      "href": "#/#footnote-1640",
      "id": "footnote-1640-backlink"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" “The Axial Period too ended in failure. History went on.” But that history “is determined, down to consequences I have only been able to hint at, by the conception of the Axial Period, irrespective of whether this thesis is accepted or rejected. It is a question of the manner in which the unity of mankind becomes a concrete reality for us.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1639",
      "id": "footnote-1639-backlink"
    }
  }, [_c('sup', [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Like the golden age of Hesiod and Vergil, the Axial Age is a myth by which history is measured. The eschaton is the unity of humanity, as Jaspers writes:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Unity is not a fact, but a goal. The unity of history is perhaps produced by men’s ability to understand each other in the idea of the One, in the one truth, in the world of the spirit, in which all things are meaningfully related to one another and belong together, however alien to each other they may be at the outset…. The goal is taken to be the manifestation of Being in man, the perception of being in its depths, that is, the manifestation of the Godhead."), _c('a', {
    attrs: {
      "href": "#/#footnote-1638",
      "id": "footnote-1638-backlink"
    }
  }, [_c('sup', [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Indeed, as Jaspers declares later, “can I elude history, escape from it into the timeless?”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1637",
      "id": "footnote-1637-backlink"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" His concluding chapter, “Overcoming History,” asserts that we move through history to the “supratemporal.” “Here we overstep history to the everlasting present; as historical existence in history we are above and beyond history. We overcome history by entering into the unconscious…. What matters is the demand for presentness as eternity in time…. To the transcendent consciousness of existence, history vanishes in the everlasting present.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1636",
      "id": "footnote-1636-backlink"
    }
  }, [_c('sup', [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In spite of the mythological character of Jaspers’s thesis, it is difficult to resist the impression that he is generally correct about these features. He is wrong, as Assmann notes, in focusing on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("synchronicity")]), _vm._v(" of the Axial revolution occurring all at once around the sixth century BCE. Hinduism, Buddhism, and Zoroastrianism did not exhibit all the features of “axiality” until they became part of a canon. “Decisive is the step to turn these visions into ‘cultural texts,’ to select these texts into a canon and to frame the transmission of this canon by institutions of exegesis ensuring its availability, readability, and authority over 3,000 years.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1635",
      "id": "footnote-1635-backlink"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" This process, which Assmann dates from 200 BCE to 200 CE, actually took much longer. Hindu and Buddhist “canons” were still being formed well into the twelfth century CE. Yet even critics generally concede the feature that Jaspers called “the common element” of the Axial Age. Most agree that it is the “Age of Transcendence.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1634",
      "id": "footnote-1634-backlink"
    }
  }, [_c('sup', [_vm._v("54")])]), _vm._v(" Transcendence is a multivalent term."), _c('a', {
    attrs: {
      "href": "#/#footnote-1633",
      "id": "footnote-1633-backlink"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" In Jaspers’s usage it has two connotations: the breaking out of the One from all limitations of the anthropomorphic gods, and the human self breaking through the limitations of time and space to unite with this One. Thus, Jaspers seems to imply that the theory of the emanation and return of all diverse things from the absolute simplicity of the One provides the metaphysical-mythical frame for other features of the Axial Age. Even critics like Assmann acknowledge, “The concept of the Axial Age refers to cultures and worldviews that distinguish between immanence (the this-worldly realm, home to the conditional and contingent) and transcendence (the other-worldly realm, home to the unconditional and absolute). On that basis, they tend to take a critical stance toward the world as it actually exists.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1632",
      "id": "footnote-1632-backlink"
    }
  }, [_c('sup', [_vm._v("56")])]), _vm._v(" The invisible world is aloof to the boundaries and limitations of the visible world with its natural laws, but in its union with the body the soul forgets this. Analogously, the self takes for granted the limitations imposed by social and political embedding. The crowd will continue to mistake the shadows for the reality, but the philosopher, like the shaman, leads the few to escape these bonds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What makes the Axial Age “axial,” according to Bellah, is the “breakthrough” to a theoretical understanding or “reflexivity.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1631",
      "id": "footnote-1631-backlink"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" In other words, there is a discovery of the self, the world, and the beyond that encourages focused reflection on the meaning of existence.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("The first of these facts is the emergence in the first millennium B.C. all across the Old World, at least in the centers of high culture, of the phenomenon of the religious rejection of the world characterized by an extremely negative evaluation of man and society and the exaltation of another realm of reality as alone true and infinitely valuable. This theme emerges in Greece through a long development into Plato’s classic formulation in the Phaedo that the body is the tomb or prison of the soul. In India we find perhaps the most radical of all versions of world rejection, culminating in the great image of the Buddha."), _c('a', {
    attrs: {
      "href": "#/#footnote-1630",
      "id": "footnote-1630-backlink"
    }
  }, [_c('sup', [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“In China,” Bellah adds, “Taoist ascetics urged the transvaluation of all the accepted values and withdrawal from human society,” in contrast to “the virtual absence of world rejection in primitive religions.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1629",
      "id": "footnote-1629-backlink"
    }
  }, [_c('sup', [_vm._v("59")])]), _vm._v(" “The Buddhist version of the Parable of the Cave is in an important sense the whole elaborate story of the Buddha’s life as the tradition handed it down.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1628",
      "id": "footnote-1628-backlink"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" Bellah observes that “a very different formulation is found in Israel,” though also with a greater stress on God’s transcendence."), _c('a', {
    attrs: {
      "href": "#/#footnote-1627",
      "id": "footnote-1627-backlink"
    }
  }, [_c('sup', [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Once it is accepted that there is another realm of absolute, unchanging, incorruptible, intelligible truth, goodness, and beauty, it follows naturally that people would begin to distance and disembed themselves from nature, history, society, and everything associated with bodily incarceration. The new myth is simultaneously a product of the new doctrines and a producer, since it provides the imagination with a new way of looking at things. And, as Socrates led Adeimantus to conclude, over a few generations these new myths might just take hold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My purpose is not to engage Jaspers’s thesis or its many subsequent articulations. Many of the features of the “Axial Age” I accept. However, it is definitely not a trend from polytheism toward "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("monotheism")]), _vm._v(", as frequently suggested, but rather toward "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("monism")]), _vm._v(", which I use in the modern philosophical sense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There are several types of monism, but the most fundamental meaning is that reality is one, not many; diversity is apparent, not real."), _c('a', {
    attrs: {
      "href": "#/#footnote-1626",
      "id": "footnote-1626-backlink"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v(" It is the “Religion of the One” that fosters (and is fostered by) this shift from a this-worldly frame to an otherworldly frame that encourages many of the other features that specialists associate with “axiality”:")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "bullet_emph"
  }, [_vm._v("Cosmological Level")]), _vm._v(": The world emanates into diversity from the Absolute and returns to unity. Typically, this means that only incorporeal ideas are real and material things range from being mere appearances to shadows to deceptive illusions. “The great invention of the West,” says Taylor, “was that of an immanent order in Nature, whose working could be systematically understood and explained on its own terms, leaving open the question whether this whole order had a deeper significance, and whether, if it did, we should infer a transcendent Creator beyond it.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1625",
      "id": "footnote-1625-backlink"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" The question would never have occurred to a pre-Axial person: “Is there something we’re missing in our everyday lives because we focus so much on the here-and-now?” The question presupposes a “then-and-there.”")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bullet_emph"
  }, [_vm._v("Microcosmic (Psychological) Level")]), _vm._v(": The divine soul (the real part of us) falls into diversity through embodiment and returns to the Cosmic Soul through philosophical ascent. The doctrine of transmigration (reincarnation) was as new in India as it was in Greece. It is a unique contribution of the sixth century BCE with the Upanishads, Buddha’s teaching (insofar as we know it), and Orphism in Greece.")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bullet_emph"
  }, [_vm._v("Epistemology")]), _vm._v(": Experiential knowledge conveyed through the bodily senses never rises above opinion, while gnosis—an intuitive, unmediated, and mystical vision—yields the certainty of vision. In fact, in this act the subject becomes one with the object. Instead of assuming the traditional order, one begins to question it. Ironically, skepticism will lead to absolute certainty. The autonomous individual is one who knows directly without dependence on tradition and authority. The self takes a stance outside the embedded social order, leading to disembedding, distancing, and a critical attitude toward the status quo. As Taylor observes, most of the time human beings are “naïve” rather than “reflective” in their “background” assumptions."), _c('a', {
    attrs: {
      "href": "#/#footnote-1624",
      "id": "footnote-1624-backlink"
    }
  }, [_c('sup', [_vm._v("64")])]), _vm._v(" However, a distinction between the visible and the invisible dimensions (i.e., being and becoming) provokes a host of other distinctions. This making of distinctions proliferates throughout the intellectual and social worlds, trying to create a cosmos out of a perceived chaos. The “Axial” revolution represents a massive shift resulting from making background presuppositions explicit and focal, examining them, and criticizing them in light of a new standard: reason (which is ultimately transrational gnosis).")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bullet_emph"
  }, [_vm._v("Ethically")]), _vm._v(": The “Age of Transcendence” gives birth to a new tribe in every religion—the renunciate who rejects the body, the visible world, and society as a dangerous illusion. Ritual exactitude, which is concerned with the city’s flourishing here and now, is eclipsed by ethics: universal rules for attaining individual life beyond. For the Buddhist, “The way to Nirvana involves renouncing, or at least going beyond, all forms of recognizable human flourishing.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1623",
      "id": "footnote-1623-backlink"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" Pythagoras, Socrates, Plato, and the Stoics in Greece, Hindu "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shramanas")]), _vm._v(", and Buddhist monks are preachers of salvation from everything associated with the body."), _c('a', {
    attrs: {
      "href": "#/#footnote-1622",
      "id": "footnote-1622-backlink"
    }
  }, [_c('sup', [_vm._v("66")])])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bullet_emph"
  }, [_vm._v("Politically")]), _vm._v(": Rulers, especially “divine kings,” lend authority to the status quo. When measured against universal truths that transcend this world, these traditions are revealed as oppressive illusions that oppose the individual soul’s liberation from the shackles of the body and the social world. After beholding the eternal ideas of justice, goodness, love, truth, and beauty, the soul can never allow itself to be enslaved to earthly institutions. Utopian revolution takes two forms, usually in succession: trying to remake the social world according to its eternal archetype, or renouncing this world altogether. Having beheld these realities, the philosopher rather than the ruler is in a position to determine the proper blueprint for society.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More useful in my view than the Axial Age paradigm is the distinction drawn by J. Z. Smith between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("locative")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("utopian")]), _vm._v(" outlooks.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("The former is concerned primarily with the cosmic and social issues of keeping one’s place and reinforcing boundaries. The vision is one of stability and confidence with respect to an essentially fragile cosmos, one that has been reorganized, with effort, out of previous modes of order and one whose “appropriate order” must be maintained through acts of conscious labour. We may term such locative traditions, religions of sanctification."), _c('a', {
    attrs: {
      "href": "#/#footnote-1621",
      "id": "footnote-1621-backlink"
    }
  }, [_c('sup', [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In a locative outlook, the individual feels embedded in an ordered cosmos with boundaries that must not be crossed. One belongs to a family that belongs to a clan that belongs to a city, which is the earthly copy of the archetypal society of the gods above.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Rituals sanctify the order that unites heaven and earth. Smith explains that in this perspective, “Order is something won by the gods and it is this primordial act of salvation which is renewed and reexperienced in the cult.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1620",
      "id": "footnote-1620-backlink"
    }
  }, [_c('sup', [_vm._v("68")])]), _vm._v(" This worldview is cyclical. In terms of place, the temple is the navel of the cosmos, where the ladder between gods and mortals is planted. Its time moves in the circle of annual festivals that mimetically preserve the participation of the lower world in the higher."), _c('a', {
    attrs: {
      "href": "#/#footnote-1619",
      "id": "footnote-1619-backlink"
    }
  }, [_c('sup', [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In a utopian worldview, however, “the structures of order are perceived to have been reversed.” Smith writes, “Man is no longer defined by the degree to which he harmonizes himself and his society to the cosmic patterns of order; but rather by the degree to which he can escape the patterns.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1618",
      "id": "footnote-1618-backlink"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" The star of the epic age Smith calls “Hero-That-Failed,” but the star of the utopian world is the “Hero-That-Succeeded”—succeeded, that is, in breaking through the limits of a bounded cosmos.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is the shaman who survived the Bronze Age and, across all these diverse civilizations, represents a new model for the type of individual that we recognize as the modern “self.” Fascination with shamanism has returned with considerable force in Western culture, from academic studies to movies and video games. Even as I write, the current issue of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atlantic")]), _vm._v(" includes the following insights from David Brooks on the success of U2’s Bono:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("The band’s other great strength is the pseudo-religious power of their concerts. Bono was influenced by an obscure book called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Death and Resurrection Show: From Shaman to Superstar")]), _vm._v(", by Rogan P. Taylor, which argues that modern performance culture has its ancient roots in shamanism. When we go to a concert, we enter the presence of a mystic who interacts with the spirit world and brings spiritual energies into the physical one. “We’re religious people even when we are not. We find ritual and ceremony powerful,” Bono says. “We were always interested in the ecstatic. I think our music reflects that.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1617",
      "id": "footnote-1617-backlink"
    }
  }, [_c('sup', [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In contrast with the picture of a cultural evolution toward an Axial “breakthrough,” Smith’s paradigm highlights that any society at any time can experience a revolution from a locative to a utopian stance or vice versa. Rather than a straight line, this narrative is filled with zigzags, reminding us that history is made by people, individually and socially, who often make deliberate decisions at key junctures about which parts of the cultural memory will be privileged or repressed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I will be invoking key phrases in this project that I will define here briefly. They describe the same phenomenon, but from different vantage points.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATURAL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UPERNATURALISM")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural supernaturalism")]), _vm._v(" refers to the pantheistic or panentheistic cosmotheology of this tradition."), _c('a', {
    attrs: {
      "href": "#/#footnote-1616",
      "id": "footnote-1616-backlink"
    }
  }, [_c('sup', [_vm._v("72")])]), _vm._v(" Modern historians of philosophy recognize this Orphic cosmology by terms such as absolute idealism, pantheism, or panentheism. Coining the phrase, Thomas Carlyle described it as a gospel that proclaims “an altogether (totally) new (or hitherto unconceived) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("species")]), _vm._v(" of divineness, a divineness lying much nearer home than formerly. A divineness that does not come from Judea, from Olympus, Asgard, or Mt. Meru; but is in man himself, in the heart of every living man.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1615",
      "id": "footnote-1615-backlink"
    }
  }, [_c('sup', [_vm._v("73")])]), _vm._v(" Theists believe that God created the world "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ex nihilo")]), _vm._v(" and therefore sometimes intervenes miraculously in nature; antisupernaturalists count nothing as a miracle. In contrast with both, this new mythology taught that nature itself is miraculous, loaded with inherent wonders of its own marvelous divinity that transcend materialistic explanations. Carlyle wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("That the Supernatural differs from the Natural is a great Truth, which the last century (especially in France) has been engaged in demonstrating. The Philosophers went far wrong, however, in this, that, instead of raising the natural to the supernatural, they strove to sink the supernatural to the natural. The gist of my whole way of thought is to do not the latter, but the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("former")]), _vm._v("."), _c('a', {
    attrs: {
      "href": "#/#footnote-1614",
      "id": "footnote-1614-backlink"
    }
  }, [_c('sup', [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although Carlyle assumed that this was a “new Mythus” constructed by anti-Enlightenment Romantic writers, the outlook he embraces is the Orphic myth that founded Western culture. As contemporary panentheist David Ray Griffin defines it:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("The word “panentheism,” generally thought to have been coined by Carl Friedrich Christian Krause in the early nineteenth century, refers to the doctrine that our world exists within a divine being—a doctrine often expressed by speaking of God as the “soul of the world.” This doctrine has, in the intervening period, become increasingly widespread…. This worldview is now widely called “scientific naturalism,” which in its most fundamental sense, is simply the doctrine that there are no supernatural irruptions of the world’s normal causal processes."), _c('a', {
    attrs: {
      "href": "#/#footnote-1613",
      "id": "footnote-1613-backlink"
    }
  }, [_c('sup', [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The deeper we descend into ourselves, the higher we ascend. Richard Kroner describes this well: “Man discovered that he was in the center of the world, and that he had to seek truth and guidance within himself. No outer authority can assume ultimate responsibility for the individual character of the person or for the faith that a man may accept as the ultimate source of all his decisions and norms of conduct.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1612",
      "id": "footnote-1612-backlink"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" Nature itself is divine at least in its incorporeal aspects, each organism and even plant or star animated by a soul. Where natural supernaturalism prevails, one views nature itself as possessing an inherently divine potency that awaits access and manipulation by human wisdom and magic.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("In this narrative, the official representatives of the mainstream (Christian theologians, rational philosophers, modern scientists) have always tried to suppress it, but never with any lasting success, because, like the unconscious, it is the hidden secret of their own existence, the vital source without which they could not exist. The positive religions, particularly the monotheistic ones, are “external” products of time and historical circumstance—they have had a beginning, and will have an end—but underneath them, there has always been this permanent and universal substratum: a kind of objective paganism expressing itself by symbols and myths, and grounded in the universal human search for self-knowledge, or gnosis."), _c('a', {
    attrs: {
      "href": "#/#footnote-1611",
      "id": "footnote-1611-backlink"
    }
  }, [_c('sup', [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Natural supernaturalism does not deny that there are mysterious forces that transcend materialistic explanation. What it does reject is the idea of a personal deity who is independent of the world, created it out of nothing, and intervenes in nature and history. For most theorists of secularization, including Max Weber, “disenchantment” is measured by a distinctly biblical attack on images and superstition mediated to the modern world through the sixteenth-century Reformation. For the most part, Charles Taylor and many others assume this narrative.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Israel’s monotheism is unique, Assmann notes, “For this monotheism did not evolve organically from polytheism, but broke with it by denouncing it as pagan.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1610",
      "id": "footnote-1610-backlink"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" Polytheism, or what Assmann calls “cosmotheism,” was the “other,” a gentile plague whose infectious spread in Israel the prophets condemned. By cosmotheism, he means something like what I am calling natural supernaturalism. The gods are cosmic and so easily translatable between cultures. Everyone has a sun god, sea god, and so forth; they’re just called by different names and in the so-called Axial Age they become universal cosmic principles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first exception to this ecumenism is Israel, with what Assmann calls the “Mosaic distinction.” Yahweh cannot be substituted for any foreign god; the prohibition of other gods or even images of Yahweh institutes a distinction between true and false, worship and idolatry, believers and unbelievers. Not in the myths of the nations but in the covenant history of Yahweh with his chosen people, revealed authoritatively in scripture, is the truth to be found."), _c('a', {
    attrs: {
      "href": "#/#footnote-1609",
      "id": "footnote-1609-backlink"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" The West opted for monotheism officially: “above all, however, we can see that the rejected alternative, the cosmotheism driven out by monotheism, has constantly shadowed the religious and intellectual history of the West, and in certain phases even struck at its heart.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1608",
      "id": "footnote-1608-backlink"
    }
  }, [_c('sup', [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Throughout Western history, migrations from monotheism have almost always ended up in some version of Orphic cosmotheism. However, it has never been repressed entirely but “seems to be the common denominator of Egyptian religion, Alexandrinian (Neoplatonic, Stoic, Hermetic) philosophy, and Spinozism, including the medieval traditions such as alchemy and the cabala that might have served as intermediaries.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1607",
      "id": "footnote-1607-backlink"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" Thriving in esoteric circles, sometimes underground, it has been nevertheless the primary inspiration of philosophical religion in Jewish, Christian, and Muslim contexts. Instead of a steady cultural evolution, therefore, what we find is a cultural memory with a repressed other that haunts and sometimes revolts against the dominant consciousness.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RPHISM")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The survivor throughout the Bronze Age Collapse was the shaman, whose distinctive characteristics remain sufficiently consistent to allow some generalizations. Originating in the Siberian steppes, the shaman, “one who knows,” followed the Indo-Iranian migration as it separated into Iranian and Indian peoples."), _c('a', {
    attrs: {
      "href": "#/#footnote-1606",
      "id": "footnote-1606-backlink"
    }
  }, [_c('sup', [_vm._v("82")])]), _vm._v(" More than a medicine man, he was the mediator between the underworld, this world, and the heavens. A seer of spirits, he could heal clients by controlling demons as well as bring back messages and even souls from the afterlife. He entered into trances, accompanied by dancing and drums, and conversed with animals. Often associated with shamanistic rituals were entheogens: drugs prepared for “generating the divine within.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1605",
      "id": "footnote-1605-backlink"
    }
  }, [_c('sup', [_vm._v("83")])]), _vm._v(" One may even argue that the shaman’s tribe increased under conditions of dislocation, disorganization, and decentering."), _c('a', {
    attrs: {
      "href": "#/#footnote-1604",
      "id": "footnote-1604-backlink"
    }
  }, [_c('sup', [_vm._v("84")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The shaman is literally utopian, liberated to be anywhere at any time or even everywhere all at once: above, below, beneath. From ancient shamanic circles new myths emerged along with a new utopian outlook that transformed the ritualistic focus of their respective public religions into philosophical religions focused on the One. On the one hand, this utopian impulse sought to re-create the concrete social world according to its more abstract, transcendent, and divine model. On the other hand, especially after disillusionment with this ideal was realized, utopianism turned toward the need to escape the mundane realm altogether.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The survivor of epic poetry becomes the shaman, and the shaman becomes the sage. In the name of Orpheus new myths enciphered a radically novel cosmology in which all things emanated from a single principle and return. As the microcosm of this eternal process, the individual soul falls into various bodies and seeks eagerly to escape its bodily prison and recover its unity with the One. As M. L. West explains:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("[Orpheus] stands outside the Mycenaean world…. He was hauled inside the cultural horizons of classical Hellas by being made the son of Apollo and Muse, and the ancestor of Hesiod and Homer. Yet the stories portray him not as a distant forerunner of Homer, but as a singer of a different type: one who can exercise power over the natural world and who can countermand death itself, a “shamanistic” figure. He entered Greek mythology, surely, not by way of Mycenaean saga but at a later period from Thrace, or through Thrace from further north, from regions where shamanistic practices actually existed or had existed."), _c('a', {
    attrs: {
      "href": "#/#footnote-1603",
      "id": "footnote-1603-backlink"
    }
  }, [_c('sup', [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Hans-Georg Gadamer hints at the importance of this topic, referring to “the so-called Orphic, an idea which has influenced scholarship for a long time, and which still represents a completely open realm of problems for research.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1602",
      "id": "footnote-1602-backlink"
    }
  }, [_c('sup', [_vm._v("86")])]), _vm._v(" Significant light has been shed in recent decades on this archaic mystery cult from Thrace that Pythagoras, Empedocles, and others mediated to Socrates and Plato. I summarize some of these findings in the second and third chapters of this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Orphism")]), _vm._v(" is a catchall label for what ancients themselves understood as teachings concerning the soul’s immortality, its fall into a bodily prison, and its reincarnation in various bodies “to pay the penalty” with the hope of escaping the wheel of rebirth to reunite with the One and All."), _c('a', {
    attrs: {
      "href": "#/#footnote-1601",
      "id": "footnote-1601-backlink"
    }
  }, [_c('sup', [_vm._v("87")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Symbolism of Evil")]), _vm._v(", Paul Ricoeur highlights four anthropological myths that vie for control of the Western imagination. The “Adamic Myth” distinguishes sharply between creation and fall. Given the term’s ontological associations in other paradigms, “fall” is less apt than a “unique event” of human rebellion."), _c('a', {
    attrs: {
      "href": "#/#footnote-1600",
      "id": "footnote-1600-backlink"
    }
  }, [_c('sup', [_vm._v("88")])]), _vm._v(" In sharp contrast, the “Orphic Myth,” which he calls “The Myth of the Exiled Soul and Salvation through Knowledge,” identifies the “fall” with embodiment."), _c('a', {
    attrs: {
      "href": "#/#footnote-1599",
      "id": "footnote-1599-backlink"
    }
  }, [_c('sup', [_vm._v("89")])]), _vm._v(" According to the Orphic myth, the soul is divine, “not from here … from elsewhere,” and its kinship with its origin can only be experienced through altered states of consciousness (e.g., ecstasy)."), _c('a', {
    attrs: {
      "href": "#/#footnote-1598",
      "id": "footnote-1598-backlink"
    }
  }, [_c('sup', [_vm._v("90")])]), _vm._v(" Much of what we would like to know about Orphism is lost to the hoary past, but Ricoeur’s description is supported by the evidence I present in the early chapters of this volume. The doctrines of emanation and return, including the descent and return of the soul after various reincarnations, were essential to all the new universal religions associated with the Axial Age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Contrary to the mainstream Axial thesis, however, I argue that this revolution is not the forerunner of modern disenchantment (a Romantic trope pressed by Nietzsche in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Birth of Tragedy")]), _vm._v(" and followed by Max Weber). If anything, the turn to transcendence was more enchanted than ever. It was not a shift from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mythos")]), _vm._v(" to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("logos")]), _vm._v(", as Jaspers claims, but from traditional myths that founded rituals to new ones that inculcated natural supernature. To be sure, it fostered disembedding with an attitude of critically distancing of the individual from the material and social world but only toward a vision of divine spirit infusing the whole cosmos. Far from being vestiges of an archaic age, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mythos")]), _vm._v(", mystical enthusiasm, and magic were from the beginning integral to Western rationality, the repressed other of modernity."), _c('a', {
    attrs: {
      "href": "#/#footnote-1597",
      "id": "footnote-1597-backlink"
    }
  }, [_c('sup', [_vm._v("91")])]), _vm._v(" Even within a broadly secular frame of pure immanence, as Casanova suggests, “the disenchantment of the world does not necessarily entail the disenchantment of consciousness, the decline of religion, or the end of magic. On the contrary, it is compatible with all forms of reenchantment.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1596",
      "id": "footnote-1596-backlink"
    }
  }, [_c('sup', [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We will see strange shaman-like divinities—minor characters in Homer and Hesiod—take center stage, overwhelming initiates with divine madness. Not only in Greece but far away, as the dramatist Euripides said, “Barbarians everywhere now dance for Dionysus” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bacch.")]), _vm._v(" 482)."), _c('a', {
    attrs: {
      "href": "#/#footnote-1595",
      "id": "footnote-1595-backlink"
    }
  }, [_c('sup', [_vm._v("93")])]), _vm._v(" Just as Dionysus conquered Attica with his mysteries, festivals, and plays, the legendary Orpheus sought to reconcile the god of ecstatic frenzy to his more reasonable half brother Apollo. Behind such myths are real-life transformations and negotiations among people who collectively shaped the direction of change.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As I shall show, this “Orphic” philosophy was part of a much broader transition under way in the sixth century BCE throughout Asia and Egypt. Even by the early fourth century BCE, Socrates routinely assumed his interlocutors would find Orphic tenets alien. Yet, not much later these doctrines were taken for granted and given varied combinations by creative bricoleurs."), _c('a', {
    attrs: {
      "href": "#/#footnote-1594",
      "id": "footnote-1594-backlink"
    }
  }, [_c('sup', [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Orphism could never become a religion or a school precisely because of its own beliefs. As the soul is to the body, philosophy is to the public religion. Like the shaman, the sage must be free not only from the body but also from the limited, located, and bounded world of institutions. It is the individual’s autonomous vision of the real that moistens the soul’s wings, not the myths, opinions, and dogmas of “the many.” Consequently, Orphism became a pervading influence precisely by not becoming a particular sect. It was a certain knowledge of who we are, where we came from, and where we are going. This knowledge was not based on historical events, particular things in this world judged by sense experience, or even reason, but rather upon direct intuition—gnosis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Like the body, public religions are tombs or prisons of a soul that longs to return to the One: the flight of the alone to the Alone. The birthplace of such philosophical religion was the private mystery cult of the few over against the public religion of the many. As Harold Bloom notes, “Persistent to this day among Jews, Christians, Muslims, and even secularists, ‘gnosis itself, in all its manifold forms and variants, also deserves to be called a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weltreligion")]), _vm._v(".’”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1593",
      "id": "footnote-1593-backlink"
    }
  }, [_c('sup', [_vm._v("95")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Moreover, far from abandoning the mythological outlook of the East, the new mythology borrowed heavily from oriental stories. We have only to listen to the sages themselves, for whom a journey to the East was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("de rigueur")]), _vm._v(". Thales came to Egypt to learn its mysteries from its priests and convinced Pythagoras to do the same. Plato’s tale of Atlantis in the preface to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Timaeus")]), _vm._v(" has the priest of Sais lecturing Solon on the ignorance of the Greeks regarding their own past. From Socrates onward, Greeks acknowledged that these ideas, though new to them, were gifts from more enlightened foreigners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the Greek enlightenment, we will see, the shaman became the sage. Several seventh-century shamanistic figures appeared on the Greek Ionian (i.e., Turkish) coast, where the first inklings of Presocratic philosophy emerged. Terpander, the founder of classical Greek music, was sent from Lesbos to Sparta on a purification mission."), _c('a', {
    attrs: {
      "href": "#/#footnote-1592",
      "id": "footnote-1592-backlink"
    }
  }, [_c('sup', [_vm._v("96")])]), _vm._v(" Associated with Orpheus, he healed Sparta through “communal musical therapy.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1591",
      "id": "footnote-1591-backlink"
    }
  }, [_c('sup', [_vm._v("97")])]), _vm._v(" Thaletas of Gortyn, a follower of Terpender and a pupil of Onomacritus (the editor of Orphic oracles), delivered Sparta from a plague around 670 BCE."), _c('a', {
    attrs: {
      "href": "#/#footnote-1590",
      "id": "footnote-1590-backlink"
    }
  }, [_c('sup', [_vm._v("98")])]), _vm._v(" The soul of Hermotimus of Clazomenae went on nocturnal journeys while his body was in a trance."), _c('a', {
    attrs: {
      "href": "#/#footnote-1589",
      "id": "footnote-1589-backlink"
    }
  }, [_c('sup', [_vm._v("99")])]), _vm._v(" According to Aristotle, Hermotimus formulated the dualistic theory of mind over matter before Anaxagoras and Parmenides."), _c('a', {
    attrs: {
      "href": "#/#footnote-1588",
      "id": "footnote-1588-backlink"
    }
  }, [_c('sup', [_vm._v("100")])]), _vm._v(" The seventh-century healer Aristeas from Proconnesus (a Greek colony in Asia Minor) converted himself into a raven at will to accompany Apollo and could die and reawaken at different times and places."), _c('a', {
    attrs: {
      "href": "#/#footnote-1587",
      "id": "footnote-1587-backlink"
    }
  }, [_c('sup', [_vm._v("101")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Right at the dawn of the Greek enlightenment we find colorful shamanic figures like Pherecydes, Epimenides, Pythagoras, and Empedocles. All of them were involved in varying degrees with the rise of political democracy, natural philosophy, mathematics, and classical music. And they also projected the persona of the shaman, the “Divine Man” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("theios anēr")]), _vm._v("). Initiated in caves, they reappeared as gods."), _c('a', {
    attrs: {
      "href": "#/#footnote-1586",
      "id": "footnote-1586-backlink"
    }
  }, [_c('sup', [_vm._v("102")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERENNIAL")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILOSOPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Perennial philosophy")]), _vm._v(" refers to a genealogy of sages who taught the above doctrine. In short, the central doctrines identified as “Orphic” (macrocosmic cycle of emanation-reversion-unity; microcosmic incarnation-reincarnation-release) are part of an esoteric heritage that public religions disdain. Its most successful mediators have had to demonstrate that they remained in the bounds of established orthodoxy. Introducing the Renaissance version, Marsilio took Hermes Trismegistus as the fountainhead (along with Zoroaster in Persia), followed by Orpheus and Aglaophemus (who initiated the Orphic mysteries), Pythagoras and Philolaus, “teacher of our divine Plato.” “In this way, from a wondrous line of six theologians emerged a single system of ancient theology, harmonious in every part.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1585",
      "id": "footnote-1585-backlink"
    }
  }, [_c('sup', [_vm._v("103")])]), _vm._v(" By 1484, the date of his preface to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Plotinus Commentary")]), _vm._v(", the perennial tradition led to Iamblichus and Proclus. For Jaspers, such a “single system of ancient theology, harmonious in every part” unified not only diverse sages but all the main disciplines that modernity divides sharply into the categories of secular and sacred.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In contrast with the modernist metanarrative of progress from the childhood of superstition to the adulthood of reason and science, the perennial-tradition metanarrative sees natural supernaturalism as the ideal toward which the most enlightened sages have oriented themselves. Instead of progress, modernity represents a decline. With roots in Romanticism, it is anti-Enlightenment and sees modernity as a soulless materialism and calculative reason that has quenched the Western spirit, something Max Weber called “the disenchantment of the world.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1584",
      "id": "footnote-1584-backlink"
    }
  }, [_c('sup', [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A good example of this theosophical account is Aldous Huxley’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perennial Philosophy")]), _vm._v(". He defines perennial philosophy as “spiritual religion” exemplified in “the devout contemplatives of India, the Sufis of Islam, the Catholic mystics of the later Middle Ages,” and, among Anabaptists, “[Hans] Denck, Sebastian Franck and Castellio, as Everard and John Smith and the first Quakers and William Law.” In this best and highest religion, shorn of creeds and rituals, one finds the divine within. One finds the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ultimate")]), _vm._v(" reality that his or her inner self is part of the divine All not in scriptures that relate mere historical events of the past but in the inner light that beholds eternal truths directly. As in the Orphic (Platonic) tradition, “spiritual religions” of all stripes regard the body as the individualizing and particularizing aspect that must be transcended in order to attain (or recognize) this unity."), _c('a', {
    attrs: {
      "href": "#/#footnote-1583",
      "id": "footnote-1583-backlink"
    }
  }, [_c('sup', [_vm._v("105")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am less interested in whether Neoplatonists, or for that matter Plato himself, represented an original Orphism correctly—or even whether there was such a phenomenon—than in the trail of sages who did. It is the effective history of the bricoleurs who claimed Orpheus’s inspiration that blazed the trail of what has come to be called the perennial tradition. In fact, the first Greek references to Zoroastrianism are made by Plato and his circle."), _c('a', {
    attrs: {
      "href": "#/#footnote-1582",
      "id": "footnote-1582-backlink"
    }
  }, [_c('sup', [_vm._v("106")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILOSOPHICAL")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ELIGION")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Borrowing on Carlos Fraenkel’s illuminating study, I mean by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("philosophical religions")]), _vm._v(" the idea that there is a universal and unchanging truth above all the opinions of diverse religions and schools. At their best, particular myths and cults point to reality, but philosophical contemplation rises above them. The goal of philosophical religion is to grow from the childhood of dependence on external authorities and the myths and rites associated with bodily life in the visible world to the autonomy of adulthood, which represents a direct and immediate vision of the truth itself with the inner eye. Since it first swept across Greece in the sixth century BCE as part of a much wider trend, it has become a default setting for what is often signaled vaguely by the phrase “spiritual but not religious.” It developed into what Fraenkel describes as “philosophical religion” that claims to transcend all particular religions."), _c('a', {
    attrs: {
      "href": "#/#footnote-1581",
      "id": "footnote-1581-backlink"
    }
  }, [_c('sup', [_vm._v("107")])]), _vm._v(" Though nothing like an evolving institution, the Orphic tradition has been seen by proponents as a perennial wisdom accessed by the great sages across all religions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Scouring miscellaneous wisdom from the archives of the Alexandrian library, Clement of Alexandria emphasizes that the greatest discoveries not only in philosophy but also in the arts, culture, and technology came to Athens from elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("So philosophy reached a climax long ago among the non-Greeks as something precious, and shone brightly through the people and later reached the Greeks. Its main authorities were the prophets of the Egyptians, the Chaldaeans among the Assyrians, the Druids among the Gauls, the Samanaeans in Bactria [northern India], among the Celts their own philosophers, the Magi among the Persians (who by their magic powers actually foretold the Savior’s birth, arriving in the land of Judaea led by a star), the Gymnosophists in India, and others called Sarmans [Hindu monks] and Brahmans [priests]. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strom.")]), _vm._v(" 1.15.71[4–5])"), _c('a', {
    attrs: {
      "href": "#/#footnote-1580",
      "id": "footnote-1580-backlink"
    }
  }, [_c('sup', [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I shall show a little later,” he continues, “that the Greek sages were somewhat after the date of Moses” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strom.")]), _vm._v(" 1.14.60[1]). This allowed Clement to display the borrowing of the Greeks not only from “barbarians” but from God’s revelation to Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such genealogies synthesized what the Greeks had known all along; namely, that Athens had arrived rather late to the society of philosophers, receiving its wisdom and magic from the East. By the time of Hellenistic philosophers like Plutarch, it was generally known what Orphism was and that it represented the highest wisdom of all sages. Adding their own brushstrokes, Neoplatonists confirmed this portrait. According to Proclus, “All the theology of the Greeks comes from Orphic mystagogy.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1579",
      "id": "footnote-1579-backlink"
    }
  }, [_c('sup', [_vm._v("109")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unlike most religions, natural supernaturalism eschews the theistic package: a personal god wholly other than the self and the world with whom a relation is mediated by personal communication of truths and practices (i.e., revealed religion). The goal of life, then, is to enrich one’s own inner experiences and interpretations—to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")]), _vm._v(" the realities rather than to be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("told")]), _vm._v(" about them. Descriptions of contemporary spirituality versus religion suggest easy comparison: “The goal is not to defer to a higher authority, but to have the courage to become one’s own authority.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1578",
      "id": "footnote-1578-backlink"
    }
  }, [_c('sup', [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Autonomy is not only allowed by Orphic spirituality; it is the goal of philosophical religion. This is why it seems more plausible to believe, for example, in the soul’s reincarnation than in bodily resurrection, in the mysterious forces of nature we experience directly than in the miraculous interventions of a creator mediated by external authority, in private spiritual beliefs and practices rather than in belonging to organized religion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Philosophical religions invoke dogmas higher than anything in history. Jaspers himself employs this “god’s-eye” view in his concluding chapter. The facts of the Axial Age are to be seen as “the basis of our universal conception of history … "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("common to all mankind")]), _vm._v(", beyond all differences of creed.” How can Moses represent God as saying that he, Yahweh, alone is God? This requires everyone to embrace a local Jewish deity of whom they have never even heard. And how can Jesus say, “I am the the way, the truth, and the life; no one comes to the Father except through me” (John 14:6)? “The transcendental history of the revealed Christian faith is made up out of the creation, the fall, stages of revelation, prophecies, the appearance of the Son of God, redemption and the last judgement…. That which binds all men together, however, cannot be revelation but must be experience. Revelation is the form taken by particular historical creeds, experience is accessible to man as man.” In contrast with “the erroneous claim to exclusive possession of truth by any one creed,” Jaspers asserts, the Axial Age was a universal phenomenon. “The claim to exclusive possession of truth, that tool of fanaticism, of human arrogance and self-deception through the will to power, that disaster for the West—most intensely so in its secularised forms, such as the dogmatic philosophies and the so-called scientific ideologies—can be vanquished by the very fact that God has manifested himself historically in several fashions and has opened up many ways toward himself.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1577",
      "id": "footnote-1577-backlink"
    }
  }, [_c('sup', [_vm._v("111")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In short, cosmotheism, pantheism/panentheism, natural supernaturalism, Orphism, perennial wisdom, and philosophical religions are synonyms for the phenomenon I am describing. “Orpheus brought the idea of Hen kai pan to Greece,” says Assmann, “where it influenced the philosophies of Pythagoras, Herakleitus, Parmenides, the Stoics.” “Hen kai pan—the conviction that one is all and all is one—was believed to be the nucleus of a great tradition that began in Egypt and was handed down to modernity.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-1576",
      "id": "footnote-1576-backlink"
    }
  }, [_c('sup', [_vm._v("112")])]), _vm._v(" Whatever the plight of traditional theistic religions in the world today, “spirituality” is flourishing, as it always has when monotheism loses its appeal. Orphic spirituality is far from the whole story, but it is a large part that is neglected except in specialized enclaves of esotericism scholarship. As contemporary polls and academic debates underscore, “secularization” is actually a spiritualizating distillation of existing religions considered too particular, this-worldly, and dogmatic. Yet such “philosophical religion” is an alternative religion with its own nonnegotiable dogmas and rituals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The history of Western civilization cannot be reduced to Orphic philosophy and Hermetic magic. Yet it cannot be understood without it. The so-called Axial revolution was not something that happened once upon a time in the sixth century BCE. Rather, it has always been the native religion of Western culture. Challenges to the public religion of Athens and of Christendom have always asserted the “Religion of the One”—the perennial tradition of the One as everything and everything as the One.")]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1687-backlink",
      "id": "footnote-1687"
    }
  }, [_vm._v("1")]), _vm._v(". Paglia, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sexual Personae")]), _vm._v(", 40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1686-backlink",
      "id": "footnote-1686"
    }
  }, [_vm._v("2")]), _vm._v(". The category was coined in Erlandson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spiritual but Not Religious")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1685-backlink",
      "id": "footnote-1685"
    }
  }, [_vm._v("3")]), _vm._v(". Heelas and Woodhead, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spiritual Revolution")]), _vm._v(", 3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1684-backlink",
      "id": "footnote-1684"
    }
  }, [_vm._v("4")]), _vm._v(". Heelas and Woodhead, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spiritual Revolution")]), _vm._v(", 5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1683-backlink",
      "id": "footnote-1683"
    }
  }, [_vm._v("5")]), _vm._v(". Repstad, “Religious Individualism,” 181.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1682-backlink",
      "id": "footnote-1682"
    }
  }, [_vm._v("6")]), _vm._v(". This 2019 statistic was taken from the Pew Research Center, “Decline of Christianity.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1681-backlink",
      "id": "footnote-1681"
    }
  }, [_vm._v("7")]), _vm._v(". Burge, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nones")]), _vm._v(", 2, 65. In 1996, 10 percent of US adults were self-identified “nones” (no religious affiliation). By 2018, this demographic reached the size of the two largest religious groups in the United States (Roman Catholic and Protestant), and by 2021 grew to 23 percent of the adult population. See Pew Research Center, “Religiously Unaffiliated.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1680-backlink",
      "id": "footnote-1680"
    }
  }, [_vm._v("8")]), _vm._v(". Over a mere five years (2012–2017), the percentage of “spiritual but not religious” in Western Europe jumped from 19 to 27 percent. See Pew Research Center, “Being Christian in Western Europe,” 119. Significantly, 53 percent claim to be “neither spiritual nor religious.” However, I offer evidence below for the conclusion that even among these, spirituality (or at least interest in the “supernatural,” particularly the occult) is quite high.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1679-backlink",
      "id": "footnote-1679"
    }
  }, [_vm._v("9")]), _vm._v(". See "), _c('a', {
    attrs: {
      "href": "https://ec.europa.eu/commfrontoffice/publicopinion/archives/ebs/ebs_224_report_en.pdf",
      "target": "_blank"
    }
  }, [_vm._v("https://ec.europa.eu/commfrontoffice/publicopinion/archives/ebs/ebs_224_report_en.pdf")]), _vm._v(", accessed 6/20/2020.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1678-backlink",
      "id": "footnote-1678"
    }
  }, [_vm._v("10")]), _vm._v(". National Science Foundation, “Science and Technology,” 26.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1677-backlink",
      "id": "footnote-1677"
    }
  }, [_vm._v("11")]), _vm._v(". Thirty-three percent of evangelicals believe in psychics, and 36 percent of Roman Catholics believe in reincarnation. See Pew Research Center, “‘New Age’ Beliefs.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1676-backlink",
      "id": "footnote-1676"
    }
  }, [_vm._v("12")]), _vm._v(". See Pew Research Center, “‘New Age’ Beliefs.” Although nearly half of evangelicals affirm at least one New Age tenet, it is noteworthy that the percentage rises significantly among more liberal Protestants and reaches 78 percent among the “nones.” Statistically, the beneficiary of this decline in Christian participation (measured by behavior, belief, and belonging) is not atheism or scientific materialism but a pantheistic type of spirituality.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1675-backlink",
      "id": "footnote-1675"
    }
  }, [_vm._v("13")]), _vm._v(". Belief that astrology is scientific is highest among eighteen- to twenty-nine-year-olds (40 percent) versus those sixty-five and older (23 percent). “Things happen that can’t be explained by science or natural causes” was affirmed by 83 percent of respondants (atheists: 34 percent; agnostics: 65 percent). Moreover, seven out of ten respondents agreed that the living can experience the presence of the dead, and half of respondents said they had been personally helped by them (even two-thirds of nones). Although Protestants traditionally deny the assistance of souls in heaven, 38 percent of evangelicals believe that one may receive help from the deceased, and 35 percent believe that one can communicate with them. See Pew Research Center, “Few Americans Blame God,” 14.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1674-backlink",
      "id": "footnote-1674"
    }
  }, [_vm._v("14")]), _vm._v(". Busker, “Witchcraft Is on the Rise”; Burton, “Rise of Progressive Occultism.” See Burton’s considerable documentation and explanation of the rise in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strange Rites")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1673-backlink",
      "id": "footnote-1673"
    }
  }, [_vm._v("15")]), _vm._v(". On the evolution of the prosperity gospel (and much else in American religious culture) from New Thought, see the suberb study by Haller, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of New Thought")]), _vm._v(". The prosperity gospel (also called “Word of Faith”) has been enormously successful abroad, especially in Africa and South America. Though the object of a barrage of evangelical critiques in the past thirty years, many recent advocates (including close advisors of former president Trump) are now considered by the media—and political allies—as mainstream evangelicals. The list of evangelical critiques of the movement is too lengthy to include here. For one example, see McConnel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Different Gospel")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1672-backlink",
      "id": "footnote-1672"
    }
  }, [_vm._v("16")]), _vm._v(". Steve Bruce offers compelling evidence that the interest in “alternative spiritualities,” including the New Age movement, is simply part of the process leading from belief to unbelief. For example, those with “fuzzy” religious identities do not believe that there is only one way of salvation and so do not take “their” way with the same seriousness as traditional believers. Consequently, they neither proselytize outsiders nor catechize their young. The next generation joins the ranks of the “neither spiritual nor religious” ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secularization")]), _vm._v(", 165–73). Even if Bruce is right, though, “spiritual but not religious” has persisted as a major tradition throughout our history to the present. If de-Christianization accounts for this phenomenon, then it has been happening for a long time and, in all likelihood, will continue. Without discounting Bruce’s evidence, his conclusions seem a bit too dismissive of “spirituality” as nothing more than a weigh station to agnostic or atheistic positions.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1671-backlink",
      "id": "footnote-1671"
    }
  }, [_vm._v("17")]), _vm._v(". “In Europe, there seems to be even more widespread belief [than in the United States] that astrology is scientific”—53 percent according to a European Commission study in 2001. See Allum and Stoneman, “Astrology in Europe,” 302.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1670-backlink",
      "id": "footnote-1670"
    }
  }, [_vm._v("18")]), _vm._v(". Bruce, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secularization")]), _vm._v(", 22, 103, 155.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1669-backlink",
      "id": "footnote-1669"
    }
  }, [_vm._v("19")]), _vm._v(". Taylor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secular Age")]), _vm._v(", 427.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1668-backlink",
      "id": "footnote-1668"
    }
  }, [_vm._v("20")]), _vm._v(". Tillich, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Christian Thought")]), _vm._v(", 286–87.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1667-backlink",
      "id": "footnote-1667"
    }
  }, [_vm._v("21")]), _vm._v(". Kołakowski, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chrétiens sans Église")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1666-backlink",
      "id": "footnote-1666"
    }
  }, [_vm._v("22")]), _vm._v(". David W. Anthony provides an elegant and informed narrative in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bronze Age Riders")]), _vm._v("; cf. Cavelli-Sforza, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History and Geography of Human Genes")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1665-backlink",
      "id": "footnote-1665"
    }
  }, [_vm._v("23")]), _vm._v(". Mallory, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Search of the Indo-Europeans")]), _vm._v(", 58–59.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1664-backlink",
      "id": "footnote-1664"
    }
  }, [_vm._v("24")]), _vm._v(". Mallory and Mair, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tarin Mummies")]), _vm._v(", 257.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1663-backlink",
      "id": "footnote-1663"
    }
  }, [_vm._v("25")]), _vm._v(". See Lowe, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Participles in Rigvedic Sanskrit")]), _vm._v(", 1–2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1662-backlink",
      "id": "footnote-1662"
    }
  }, [_vm._v("26")]), _vm._v(". These cognates include human ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("manu")]), _vm._v("), spirits ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("asura/ahura")]), _vm._v("), evil spirit ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("druh/druj")]), _vm._v("), sun ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("svar/hvar")]), _vm._v("), waters ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ap")]), _vm._v(")"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(",")]), _vm._v(" heaven ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ashman")]), _vm._v("/"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("asman")]), _vm._v("), prosperity ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("usij")]), _vm._v("), priest ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bhaga/baga")]), _vm._v("), covenant ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mitra/mithra")]), _vm._v("), sacred spell ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mantra")]), _vm._v("/"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("manthra")]), _vm._v("). Many names of deities ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("deva/daeva")]), _vm._v(") are shared: Supreme Lord of Wisdom (Asura Mahata/Ahura Mazda), Yama/Yima, Sarva (the Rigvedic attribute of Rudra that becomes hypostatized as Shiva), and others. See Griswold and De Witt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Religion of the Rigveda")]), _vm._v(", 20–21.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1661-backlink",
      "id": "footnote-1661"
    }
  }, [_vm._v("27")]), _vm._v(". Zeus fits the pattern we find with Set (Middle Egyptian), Indra (Indic), Ahura Mazda (Iranian), Wotan (Germanic), Odin (Norse), Perun (Slavic), Ba’al (Canaanite/Phoenician), and Teshnub (Hurrian).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1660-backlink",
      "id": "footnote-1660"
    }
  }, [_vm._v("28")]), _vm._v(". See Te Velde, “Seth,” 3:269.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1659-backlink",
      "id": "footnote-1659"
    }
  }, [_vm._v("29")]), _vm._v(". See Drews, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("End of the Bronze Age")]), _vm._v(". The dates range more broadly depending on the civilization in question, but the most devastating impact generally occurs in this window.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1658-backlink",
      "id": "footnote-1658"
    }
  }, [_vm._v("30")]), _vm._v(". Natural disasters such as volcanic eruptions and earthquakes have been suggested as causes for the Bronze Age Collapse, but the dominant theory for more than a century has been waves of invading “Sea Peoples.” Some evidence suggests these Sea Peoples were Mycenaean Greeks, toppling the Hittite Empire and settling in Canaan as the biblical Philistines. Inscriptions in Egypt, Mari, and Syria mention “Caphtor,” located in Crete, where the Minoans created the first European civilization. Moreover, Mycenaean pottery has been found all over southern Canaan (i.e., Philistia). In Amos 9:7, Yahweh declares, “Did I not bring up Israel from the land of Egypt, and the Philistines from Caphtor and the Syrians from Kir?” (cf. Gen 10:13–14; 1 Chr 1:11–12). See Redford, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Egypt, Canaan, and Israel")]), _vm._v(". A study found that the genetic makeup of Iron Age inhabitants of the region differs from that of the Bronze Age; see Feldman et al., “Iron Age Philistines.” For a thorough review of the secondary literature see Woudhuisen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Language of the Sea Peoples")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1657-backlink",
      "id": "footnote-1657"
    }
  }, [_vm._v("31")]), _vm._v(". At the same time, immigrants from the Balkans poured into teetering Mycenaean kingdoms. Many Mycenaean Greeks took refuge in recently founded colonies in Asia Minor and around the Black Sea, leaving the Aegean world a wasteland. See Meier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culture of Freedom")]), _vm._v(", 51.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1656-backlink",
      "id": "footnote-1656"
    }
  }, [_vm._v("32")]), _vm._v(". Grant, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ancient Mediterranean")]), _vm._v(", 79.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1655-backlink",
      "id": "footnote-1655"
    }
  }, [_vm._v("33")]), _vm._v(". Arnason, “Rehistoricizing the Axial Age,” 346–47.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1654-backlink",
      "id": "footnote-1654"
    }
  }, [_vm._v("34")]), _vm._v(". See Seaford, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Money")]), _vm._v(". Surprisingly little work has appeared on the influence of factors in the Axial revolution other than ideas. Seaford overcorrects at points but draws insightful connections from detailed research.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1653-backlink",
      "id": "footnote-1653"
    }
  }, [_vm._v("35")]), _vm._v(". Meier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culture of Freedom")]), _vm._v(", 52–53.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1652-backlink",
      "id": "footnote-1652"
    }
  }, [_vm._v("36")]), _vm._v(". I take this from the title of Frederick Copleston’s 1979 Gifford Lectures, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Religion and the One")]), _vm._v(". However, I argue that Zoroastrianism and the Hebrew prophets emphasize monotheism while the wider Axial trend is toward monism (i.e., pantheism or panentheism).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1651-backlink",
      "id": "footnote-1651"
    }
  }, [_vm._v("37")]), _vm._v(". For reasons I explain later, the biblical prophets and Zoroastrianism are less susceptible to this generalization.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1650-backlink",
      "id": "footnote-1650"
    }
  }, [_vm._v("38")]), _vm._v(". Turner, “Ontological Pluralism,” 5–34.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1649-backlink",
      "id": "footnote-1649"
    }
  }, [_vm._v("39")]), _vm._v(". Jaspers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin and Goal of History")]), _vm._v(", 1. Subsequent references are given in the text.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1648-backlink",
      "id": "footnote-1648"
    }
  }, [_vm._v("40")]), _vm._v(". Voegelin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In Search of Order")]), _vm._v(", esp. 37–47. As the latter two monikers imply, the thesis tends toward a metanarrative about where history "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("should")]), _vm._v(" be going, which happens to coincide with a “new age” anticipated by Romanticism’s antimodern trend. More recently, Karen Armstrong has called it “The Great Transformation,” that is, when religious dogmatism was replaced by self-transformation and the idea that “All is One”; see Armstrong, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Transformation")]), _vm._v(". Given her expertise, this is a surprisingly shallow jeremiad, chockful of trite and vaguely New Age contrasts between dogmatists (i.e., theists) and “the great mystics, philosophers and poets” of the Axial Age. It is more about “our modern predicament” than a historical report. In a more nuanced version, Charles Taylor’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secular Age")]), _vm._v(" nevertheless perpetuates the disenchantment narrative of Max Weber and John Milbank with the Hebrew prophets (culminating in the Protestant Reformation) as the extinguishers of the sacred. Focused appropriation of the thesis is found throughout Taylor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secular Age")]), _vm._v(", 146–58, 308, 438–39, 578, 611–14, 685–89, 770–74. Critiques of the Axial Age thesis are plentiful. See for example Provan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conventional Myths")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1647-backlink",
      "id": "footnote-1647"
    }
  }, [_vm._v("41")]), _vm._v(". Burkert, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Babylon, Memphis, Persepolis")]), _vm._v(", 74. Defenders of the “Axial Age” thesis tend to be on the “mystical” side of Burkert’s divide.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1646-backlink",
      "id": "footnote-1646"
    }
  }, [_vm._v("42")]), _vm._v(". See the introduction to Lyotard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Postmodern Condition")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1645-backlink",
      "id": "footnote-1645"
    }
  }, [_vm._v("43")]), _vm._v(". Joas, “Axial Age Debate,” 10–24. In the aftermath of the Second World War, Jaspers, a disaffected Protestant, contributed to a more cosmopolitan “enlightenment” than traditional descriptions of a “Greek Miracle.” Nevertheless, he introduces a new division between “unawakened” and “awakened” cultures that, with his rigid definitions of the elements of the Axial Age, sounds a lot like “premodern” and “modern.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1644-backlink",
      "id": "footnote-1644"
    }
  }, [_vm._v("44")]), _vm._v(". Assmann, “Cultural Memory,” 373.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1643-backlink",
      "id": "footnote-1643"
    }
  }, [_vm._v("45")]), _vm._v(". Assmann, “Cultural Memory,” 375–76, referring to Voegelin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Israel and Revelation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1642-backlink",
      "id": "footnote-1642"
    }
  }, [_vm._v("46")]), _vm._v(". Jaspers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin and Goal of History")]), _vm._v(", 20. An example of his “view from nowhere” is his judgment of Augustine. Reading Augustine brings the reader’s conscience to the fore in a way unexamined by the Greeks. “Conversely, however, after spending some time on St. Augustine, he will experience an increasing desire to return to the Greeks and cleanse himself of the feeling of impurity that seems to grow with the pursuit of this type of thinking, to regain his health by immersion in the pellucid waters of Greek thought. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nowhere on earth can we find final truth, authentic salvation")]), _vm._v("” (20, emphasis added). Combined with his metaphysics and eschatology, one might conclude with some justification that Jaspers accepts a gnostic verdict on history.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1641-backlink",
      "id": "footnote-1641"
    }
  }, [_vm._v("47")]), _vm._v(". Jaspers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin and Goal of History")]), _vm._v(", 1. Ironically, he says later that philosophy of history originated from a secularization of Christianity’s notion of creation, fall, redemption, and consummation—particularly “St. Augustine’s total conception” (186).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1640-backlink",
      "id": "footnote-1640"
    }
  }, [_vm._v("48")]), _vm._v(". Jaspers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin and Goal of History")]), _vm._v(", 5–6.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1639-backlink",
      "id": "footnote-1639"
    }
  }, [_vm._v("49")]), _vm._v(". Jaspers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin and Goal of History")]), _vm._v(", 20–21.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1638-backlink",
      "id": "footnote-1638"
    }
  }, [_vm._v("50")]), _vm._v(". Jaspers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin and Goal of History")]), _vm._v(", 257.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1637-backlink",
      "id": "footnote-1637"
    }
  }, [_vm._v("51")]), _vm._v(". Jaspers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin and Goal of History")]), _vm._v(", 271.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1636-backlink",
      "id": "footnote-1636"
    }
  }, [_vm._v("52")]), _vm._v(". Jaspers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin and Goal of History")]), _vm._v(", 273, 276.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1635-backlink",
      "id": "footnote-1635"
    }
  }, [_vm._v("53")]), _vm._v(". Assmann, “Cultural Memory,” 399. As Assmann notes, writing began long before the Axial Age as a sectoral (record-keeping) enterprise. However, the “primary canonization” of texts began as a process of oral transmission over many centuries. It is “secondary canonization”—the fixing of a particular set of texts as normative—that marks axiality. It generates “a culture of exegesis as its necessary complement” that makes it a living feature of the cultural memory.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1634-backlink",
      "id": "footnote-1634"
    }
  }, [_vm._v("54")]), _vm._v(". Schwartz, “Age of Transcendence,” 1–7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1633-backlink",
      "id": "footnote-1633"
    }
  }, [_vm._v("55")]), _vm._v(". Ingolf U. Dalferth offers an extensive and penetrating analysis of different connotations in his essay “Idea of Transcendence.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1632-backlink",
      "id": "footnote-1632"
    }
  }, [_vm._v("56")]), _vm._v(". Assmann, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Invention of Religion")]), _vm._v(", 7.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1631-backlink",
      "id": "footnote-1631"
    }
  }, [_vm._v("57")]), _vm._v(". Bellah, “Axial Age,” 69.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1630-backlink",
      "id": "footnote-1630"
    }
  }, [_vm._v("58")]), _vm._v(". Bellah, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beyond Belief")]), _vm._v(", 22–23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1629-backlink",
      "id": "footnote-1629"
    }
  }, [_vm._v("59")]), _vm._v(". Bellah, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beyond Belief")]), _vm._v(", 22–23. We see an example of this in Chuang Tzu, also known as Zhuangzi (310–230 BCE), who distinguishes the two realms sharply, referring to the “Genuine-Humans of old”: “In their oneness, they were followers of the Heavenly. In their non-oneness, they were followers of the human.” Chuang Tzu, “Great Source as Teacher,” 55. The heavenly/human contrast appears throughout this chapter.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1628-backlink",
      "id": "footnote-1628"
    }
  }, [_vm._v("60")]), _vm._v(". Bellah, “Heritage,” 459.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1627-backlink",
      "id": "footnote-1627"
    }
  }, [_vm._v("61")]), _vm._v(". Bellah, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beyond Belief")]), _vm._v(", 22. Proponents of the axial thesis frequently overlook the extent to which Israel is an exception. There are parallels, which I indicate, but within a radically different outlook than is present in either primitive or “axial” periods. It would require more evidence to conclude with Bellah here that, despite the different formulation, “there too the world is profoundly devalued in the face of the transcendent God.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1626-backlink",
      "id": "footnote-1626"
    }
  }, [_vm._v("62")]), _vm._v(". See for example Schaeffer, “Monism.” I find often among Axial theorists the conflation of monism and monotheism, but pantheism/panentheism is of course radically different from theism. Sometimes monism is used to refer to the pre-Axial belief in one world with gods in it, but in this case monism is confused with polytheism.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1625-backlink",
      "id": "footnote-1625"
    }
  }, [_vm._v("63")]), _vm._v(". Taylor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secular Age")]), _vm._v(", 15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1624-backlink",
      "id": "footnote-1624"
    }
  }, [_vm._v("64")]), _vm._v(". Taylor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secular Age")]), _vm._v(", 13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1623-backlink",
      "id": "footnote-1623"
    }
  }, [_vm._v("65")]), _vm._v(". Taylor, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Secular Age")]), _vm._v(", 17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1622-backlink",
      "id": "footnote-1622"
    }
  }, [_vm._v("66")]), _vm._v(". Differences are also apparent. For example, Orphic-Platonic asceticism is enflamed with desire for “flourishing” by achieving transcendence while Buddhist ascetics aim at the extinction of all desire as the root of suffering.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1621-backlink",
      "id": "footnote-1621"
    }
  }, [_vm._v("67")]), _vm._v(". Smith, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Drudgery Divine")]), _vm._v(", 121.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1620-backlink",
      "id": "footnote-1620"
    }
  }, [_vm._v("68")]), _vm._v(". Smith, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Map Is Not Territory")]), _vm._v(", 13.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1619-backlink",
      "id": "footnote-1619"
    }
  }, [_vm._v("69")]), _vm._v(". The name of Mircea Eliade is associated with comparisons relating to sacred space and time. See especially Eliade, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Myth of Eternal Return")]), _vm._v("; Eliade, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sacred and Profane")]), _vm._v("; Eliade, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Myth and Reality")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1618-backlink",
      "id": "footnote-1618"
    }
  }, [_vm._v("70")]), _vm._v(". Smith, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Map Is Not Territory")]), _vm._v(", 139.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1617-backlink",
      "id": "footnote-1617"
    }
  }, [_vm._v("71")]), _vm._v(". Brooks, “Too-Muchness of Bono.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1616-backlink",
      "id": "footnote-1616"
    }
  }, [_vm._v("72")]), _vm._v(". Panentheism (all is in God) differs from pantheism (all is God) in conceiving the divine Absolute as transcending (i.e., “more than”) the world that it includes in itself. See J. W. Cooper, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Panentheism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1615-backlink",
      "id": "footnote-1615"
    }
  }, [_vm._v("73")]), _vm._v(". Quoted in Baumgarten, “Carlyle’s ‘Spiritual Optics,’” 514. I first discovered Carlyle’s phrase (from his work "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sartor Resartus")]), _vm._v(", published in serial from 1833 to 1834) in Abrams, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natural Supernaturalism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1614-backlink",
      "id": "footnote-1614"
    }
  }, [_vm._v("74")]), _vm._v(". Carlyle, extracts from journal, in James Anthony Froude, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thomas Carlyle: A History of the First Forty Years of His Life, 1795–1835")]), _vm._v(" (New York: Harper and Brothers, 1882), 198.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1613-backlink",
      "id": "footnote-1613"
    }
  }, [_vm._v("75")]), _vm._v(". Griffin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Panentheism and Scientific Naturalism")]), _vm._v(", 1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1612-backlink",
      "id": "footnote-1612"
    }
  }, [_vm._v("76")]), _vm._v(". Kroner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Speculation and Revelation")]), _vm._v(", 25.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1611-backlink",
      "id": "footnote-1611"
    }
  }, [_vm._v("77")]), _vm._v(". Hanegraaff, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esotericism and the Academy")]), _vm._v(", 295")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1610-backlink",
      "id": "footnote-1610"
    }
  }, [_vm._v("78")]), _vm._v(". Assmann, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Price of Monotheism")]), _vm._v(", 39.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1609-backlink",
      "id": "footnote-1609"
    }
  }, [_vm._v("79")]), _vm._v(". Assmann presented this thesis first with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Moses")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Of God and Gods")]), _vm._v(". Conceding justifiable criticisms, he wrote a more nuanced version of his thesis in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Price of Monotheism")]), _vm._v(" and a fuller treatment in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Invention of Religion")]), _vm._v(". I remain unpersuaded by several lines of his argument, especially his claim that the Bible’s exclusive (or revolutionary) monotheism was the springboard for the Axial Age. Like many scholars, Assmann conflates monotheism with monism, and the trends identified with the Axial thesis are definitely pantheistic/panentheistic and not theistic. However, I find illuminating points along the way in his work.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1608-backlink",
      "id": "footnote-1608"
    }
  }, [_vm._v("80")]), _vm._v(". Assmann, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Price of Monotheism")]), _vm._v(", 43.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1607-backlink",
      "id": "footnote-1607"
    }
  }, [_vm._v("81")]), _vm._v(". Assmann, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Moses")]), _vm._v(", 141–42.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1606-backlink",
      "id": "footnote-1606"
    }
  }, [_vm._v("82")]), _vm._v(". Ronald Hutton adopts this derivation in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shamans")]), _vm._v("; cf. Hoppál, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sámánok Eurázsiáben")]), _vm._v(", 15. However, the etymology is highly debated. Mircea Eliade argued that the word “shaman” originated in the Sanskrit "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shramana")]), _vm._v(", which designated a mendicant visionary; see Eliade, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shamanism")]), _vm._v(", 495. See also Eliade’s summary of essential attributes of shamanistic practice on pages 3–7. Hutton relates that in 1692 Dutch scholar Nicholas Witsen in his work "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Noord en Oost Tataryen")]), _vm._v(" introduced the West to the term in his report of indigenous Siberian (Tungus-speaking) peoples"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")]), _vm._v(" See Hutton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Triumph of the Moon")]), _vm._v(", 32.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1605-backlink",
      "id": "footnote-1605"
    }
  }, [_vm._v("83")]), _vm._v(". De Souza et al., “Jurema-Preta.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1604-backlink",
      "id": "footnote-1604"
    }
  }, [_vm._v("84")]), _vm._v(". Davis-Kimball, Bashilov, and Yablonsky, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nomads of the Eurasian Steppes")]), _vm._v(". Focusing on Britain, John Creighton demonstrates with considerable evidence (e.g., coins, rock art, round houses) wide familiarity with shamanic imagery. See Williams and Creighton, “Shamanic Practice”; Creighton, “Visions of Power”; Creighton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Coins and Power")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1603-backlink",
      "id": "footnote-1603"
    }
  }, [_vm._v("85")]), _vm._v(". West, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orphic Poems")]), _vm._v(", 4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1602-backlink",
      "id": "footnote-1602"
    }
  }, [_vm._v("86")]), _vm._v(". Gadamer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beginning of Philosophy")]), _vm._v(", 38.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1601-backlink",
      "id": "footnote-1601"
    }
  }, [_vm._v("87")]), _vm._v(". I will address historical debates over whether such a coherent phenomenon existed in the classical era. More important than this question, for my purposes, is the tradition that believed it did.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1600-backlink",
      "id": "footnote-1600"
    }
  }, [_vm._v("88")]), _vm._v(". Ricoeur, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Symbolism of Evil")]), _vm._v(", 243.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1599-backlink",
      "id": "footnote-1599"
    }
  }, [_vm._v("89")]), _vm._v(". Ricoeur, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Symbolism of Evil")]), _vm._v(", 279.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1598-backlink",
      "id": "footnote-1598"
    }
  }, [_vm._v("90")]), _vm._v(". Ricoeur, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Symbolism of Evil")]), _vm._v(", 287–88.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1597-backlink",
      "id": "footnote-1597"
    }
  }, [_vm._v("91")]), _vm._v(". The repression of these features actually begins with the antipathy of the Hebrew prophets toward idolatry, superstition, and magic, which was attenuated in the Middle Ages but revived in the Reformation. This point is underscored by Charles Taylor among many others, but their further argument that this led to secularization is persuasive only if enchantment (the opposite of secularization) is defined by a quasi-polytheistic and magical cosmos. At least for biblical traditions, defending monotheism can hardly be considered a secularizing move. On the contrary, “spirituality” would be a declension from orthodoxy.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1596-backlink",
      "id": "footnote-1596"
    }
  }, [_vm._v("92")]), _vm._v(". Casanova, “Religion,” 215.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1595-backlink",
      "id": "footnote-1595"
    }
  }, [_vm._v("93")]), _vm._v(". All quotations of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bacchae")]), _vm._v(" in this volume, unless otherwise noted, from Arrowsmith, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Euripides")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1594-backlink",
      "id": "footnote-1594"
    }
  }, [_vm._v("94")]), _vm._v(". In philosophy, Claude Lévi-Strauss used the term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bricolage")]), _vm._v(" (making something from materials close to hand) to describe the way myths allow people to reconceive new ideas; see Lévi-Strauss, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Savage Mind")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1593-backlink",
      "id": "footnote-1593"
    }
  }, [_vm._v("95")]), _vm._v(". Harold Bloom, preface to Corbin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alone with the Alone")]), _vm._v(", xx, quoting Corbin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cyclical Time")]), _vm._v(", 193.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1592-backlink",
      "id": "footnote-1592"
    }
  }, [_vm._v("96")]), _vm._v(". A helpful survey of Terpander’s biography is found in Reese, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Music in the Middle Ages")]), _vm._v(", 11.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1591-backlink",
      "id": "footnote-1591"
    }
  }, [_vm._v("97")]), _vm._v(". Power, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culture of Kitharôidia")]), _vm._v(". Rich in information as well as analysis, this study is my principal resource for Terpander.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1590-backlink",
      "id": "footnote-1590"
    }
  }, [_vm._v("98")]), _vm._v(". Burkert, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orientalizing Revolution")]), _vm._v(", 42–43.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1589-backlink",
      "id": "footnote-1589"
    }
  }, [_vm._v("99")]), _vm._v(". West, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orphic Poems")]), _vm._v(", 149.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1588-backlink",
      "id": "footnote-1588"
    }
  }, [_vm._v("100")]), _vm._v(". Preus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historical Dictionary of Greek Philosophy")]), _vm._v(", 190, citing Aristotle, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Metaph.")]), _vm._v(" 984b20. Supporting Aristotle’s description is Sextus Empiricus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Math.")]), _vm._v(" 9"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")]), _vm._v("1.7. On the Pythagorean connection see Lucian, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Musc. laud.")]), _vm._v(" 7 and book 8 of Diogenes Laertius, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vit. phil")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1587-backlink",
      "id": "footnote-1587"
    }
  }, [_vm._v("101")]), _vm._v(". Herodotus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hist.")]), _vm._v(" 4.13–16. See the excellent biography by Bolton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aristeas of Proconnesus")]), _vm._v("; cf. Phillips, “Legend of Aristeas.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1586-backlink",
      "id": "footnote-1586"
    }
  }, [_vm._v("102")]), _vm._v(". Fascination with the shaman figure in scholarship over the last century is, in and of itself, fascinating. See Ginzburg, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Threads and Traces")]), _vm._v(", 83–95, 94.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1585-backlink",
      "id": "footnote-1585"
    }
  }, [_vm._v("103")]), _vm._v(". Ficino, preface to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Corpus Hermeticum")]), _vm._v(" (1462), translated in Copenhaver and Schmitt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Renaissance Philosophy")]), _vm._v(", 147.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1584-backlink",
      "id": "footnote-1584"
    }
  }, [_vm._v("104")]), _vm._v(". For a survey of the secularization paradigm’s development and consituent components, see Tschannen, “Secularization Paradigm.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1583-backlink",
      "id": "footnote-1583"
    }
  }, [_vm._v("105")]), _vm._v(". Huxley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Perennial Philosophy")]), _vm._v(", 1–34. Writing for a popular audience, Huxley highlights these characteristics of “spiritual religion” with a generous sprinkling of quotations from Eastern and Western mystics alike.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1582-backlink",
      "id": "footnote-1582"
    }
  }, [_vm._v("106")]), _vm._v(". McEvilley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shape of Ancient Thought")]), _vm._v(", 171.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1581-backlink",
      "id": "footnote-1581"
    }
  }, [_vm._v("107")]), _vm._v(". Fraenkel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Philosophical Religions")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1580-backlink",
      "id": "footnote-1580"
    }
  }, [_vm._v("108")]), _vm._v(". Clement of Alexandria, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stromateis: Books 1–3")]), _vm._v(" (trans. Ferguson).")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1579-backlink",
      "id": "footnote-1579"
    }
  }, [_vm._v("109")]), _vm._v(". Proclus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theo. Plat.")]), _vm._v(" 1.6. (= Testamenta 250 from Kern, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orphicorum fragmenta")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1578-backlink",
      "id": "footnote-1578"
    }
  }, [_vm._v("110")]), _vm._v(". Heelas and Woodhead, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spiritual Revolution")]), _vm._v(", 4.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1577-backlink",
      "id": "footnote-1577"
    }
  }, [_vm._v("111")]), _vm._v(". Jaspers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Origin and Goal of History")]), _vm._v(", 19–20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot-notes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1576-backlink",
      "id": "footnote-1576"
    }
  }, [_vm._v("112")]), _vm._v(". Assmann, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Moses")]), _vm._v(", 141–42. Assmann notes that the term “cosmotheism” was coined by Lamoignon de Malesherbes, referring to the Stoic view held by Pliny as “non un Athée, mais un Cosmo-theiste,” since Pliny believed the cosmos was god (142).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6eea94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Introduction.vue
// module id = 78
// module chunks = 0